import { Alert, LearnMoreNoteApprovalModal, LinkButton } from 'components/core-v2'
import { useState } from 'react'

import classes from './waiting-on-role-alert.module.scss'

export const WaitingOnRoleAlert = () => {
  const [isModalShowing, setIsModalShowing] = useState(false)
  return (
    <>
      <Alert
        className={classes.root}
        title="Currently waiting for the note to be approved, please check back later"
        type="information"
      >
        <LinkButton onClick={() => setIsModalShowing(true)}>
          Learn more about the approval process
        </LinkButton>
      </Alert>
      <LearnMoreNoteApprovalModal
        isOpen={isModalShowing}
        onClose={() => setIsModalShowing(false)}
      />
    </>
  )
}
